<template>
  <div class="forecast">
    <div class="forecast__item" v-for="(i, idx) in 5" :key="idx">
      <div class="forecast__day">
        <template v-if="i == 1"> Dzisiaj, </template>
        <template v-else> {{ getWeatherDayName(i - 1) }}, </template>
        <strong>{{ getWeatherDay(i - 1) }}</strong>
      </div>
      <div class="forecast__row">
        <div class="forecast__main">
          <div class="forecast__icon">
            <span class="svg-icon d-inline-flex" aria-hidden="true">
              <svg
                class="svg-icon__svg"
                width="80px"
                height="80px"
                focusable="false"
              >
                <template v-if="i == 1">
                  <use
                    :xlink:href="
                      `/img/static/svg-weather-sprites.svg#` +
                      getCurrentMeteoIcon()
                    "
                  ></use>
                </template>
                <template v-else>
                  <use
                    :xlink:href="
                      `/img/static/svg-weather-sprites.svg#` +
                      getMeteoIcon(i - 1)
                    "
                  ></use>
                </template>
              </svg>
            </span>
          </div>
          <template v-if="i == 1">
            <div class="forecast__temp">{{ getCurrentTemp() }}&#176;C</div>
          </template>
          <template v-else>
            <div class="forecast__temp">
              {{ getWeatherTempMinC(i - 1) }} -
              {{ getWeatherTempMaxC(i - 1) }}&#176;C
            </div>
          </template>
        </div>
        <div class="forecast__secondary">
          <div class="forecast__details">
            <template v-if="i == 1">
              <div class="d-flex f-sb">
                <span class="gray-60">zachmurzenie:</span
                ><span>{{ getCurrentCloudcover() }}</span>
              </div>
              <div class="d-flex f-sb">
                <span class="gray-60">widoczność:</span
                ><span>{{ getCurrentVisibility() }}</span>
              </div>
            </template>
            <div class="d-flex f-sb">
              <span class="gray-60">wschód:</span
              ><span>{{ getSunriseTime(i - 1) }}</span>
            </div>
            <div class="d-flex f-sb">
              <span class="gray-60">zachód:</span
              ><span>{{ getSunsetTime(i - 1) }}</span>
            </div>
          </div>
          <div class="forecast__details">
            <template v-if="i == 1">
              <div class="d-flex f-sb">
                <span class="gray-60">wilgotność:</span
                ><span>{{ getCurrentHumidity() }}</span>
              </div>
              <div class="d-flex f-sb">
                <span class="gray-60">ciśnienie:</span
                ><span>{{ getCurrentPressure() }}</span>
              </div>
            </template>
            <div class="d-flex f-sb">
              <span class="gray-60">opady:</span>
              <template v-if="i == 1">
                <span>{{ getCurrentPrecipitation() }}</span>
              </template>
              <template v-else>
                <span>{{ getWeatherPrecipitation(i - 1) }}</span>
              </template>
            </div>
            <div class="d-flex f-sb">
              <span class="gray-60">wiatr:</span>
              <template v-if="i == 1">
                <span
                  >{{ getCurrentWindSpeed() }} km/h
                  <a-icon
                    :style="{
                      transform: 'rotate(' + getCurrentWindDegree() + 'deg)',
                    }"
                    type="arrow-up"
                    class="c-blue-light"
                  />
                </span>
              </template>
              <template v-else>
                <span
                  >{{ getWeatherWindSpeed(i - 1) }} km/h
                  <a-icon
                    :style="{
                      transform:
                        'rotate(' + getWeatherWindDegree(i - 1) + 'deg)',
                    }"
                    type="arrow-up"
                    class="c-blue-light"
                  />
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "forecast",
  props: {
    meteoData: [Array, Object],
  },
  data: () => ({}),
  methods: {
    getWeatherDay(i) {
      if (
        this.meteoData.dni &&
        this.meteoData.dni.dzien[i] &&
        this.meteoData.dni.dzien[i].data
      ) {
        return this.meteoData.dni.dzien[i].data;
      } else {
        return "";
      }
    },
    getWeatherDayName(i) {
      if (
        this.meteoData.dni &&
        this.meteoData.dni.dzien[i] &&
        this.meteoData.dni.dzien[i]["dzien-tygodnia"]
      ) {
        return this.meteoData.dni.dzien[i]["dzien-tygodnia"];
      } else {
        return "";
      }
    },
    replaceHttpWithHttps(val) {
      if (val) {
        return val.replace("http:", "https:");
      } else {
        return "";
      }
    },
    getImageName(imageUrl) {
      if (imageUrl) {
        return imageUrl.split("\\").pop().split("/").pop().split(".")[0];
      } else {
        return "";
      }
    },
    getCurrentMeteoIcon() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.weatherIconUrl
      ) {
        return this.getImageName(
          this.meteoData.data.current_condition.weatherIconUrl
        );
      } else {
        return "";
      }
    },
    getMeteoIcon(i) {
      if (
        this.meteoData.data &&
        this.meteoData.data.weather[i] &&
        this.meteoData.data.weather[i].weatherIconUrl
      ) {
        return this.getImageName(this.meteoData.data.weather[i].weatherIconUrl);
      } else {
        return "";
      }
    },
    getWeatherTempMinC(i) {
      if (
        this.meteoData.data &&
        this.meteoData.data.weather[i] &&
        this.meteoData.data.weather[i].tempMinC
      ) {
        return this.meteoData.data.weather[i].tempMinC;
      } else {
        return "";
      }
    },
    getWeatherTempMaxC(i) {
      if (
        this.meteoData.data &&
        this.meteoData.data.weather[i] &&
        this.meteoData.data.weather[i].tempMaxC
      ) {
        return this.meteoData.data.weather[i].tempMaxC;
      } else {
        return "";
      }
    },
    getCurrentTemp() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.temp_C
      ) {
        return this.meteoData.data.current_condition.temp_C;
      } else {
        return "";
      }
    },
    getCurrentCloudcover() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.cloudcover
      ) {
        if (this.meteoData.data.current_condition.cloudcover == 0) {
          return "brak";
        } else {
          return this.meteoData.data.current_condition.cloudcover + " %";
        }
      } else {
        return "";
      }
    },
    getCurrentVisibility() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.visibility
      ) {
        if (this.meteoData.data.current_condition.visibility == 0) {
          return "pełna";
        } else {
          return this.meteoData.data.current_condition.visibility + " km";
        }
      } else {
        return "";
      }
    },
    getCurrentHumidity() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.humidity
      ) {
        if (this.meteoData.data.current_condition.humidity == 0) {
          return "brak";
        } else {
          return this.meteoData.data.current_condition.humidity + " %";
        }
      } else {
        return "";
      }
    },
    getCurrentPressure() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.pressure
      ) {
        if (this.meteoData.data.current_condition.pressure == 0) {
          return "b.d.";
        } else {
          return this.meteoData.data.current_condition.pressure + " hPa";
        }
      } else {
        return "";
      }
    },
    getCurrentPrecipitation() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.precipMM
      ) {
        if (this.meteoData.data.current_condition.precipMM == 0) {
          return "brak";
        } else {
          return this.meteoData.data.current_condition.precipMM + " mm";
        }
      } else {
        return "";
      }
    },
    getWeatherPrecipitation(i) {
      if (
        this.meteoData.data &&
        this.meteoData.data.weather[i] &&
        this.meteoData.data.weather[i].precipMM
      ) {
        if (this.meteoData.data.weather[i].precipMM == 0) {
          return "brak";
        } else {
          return this.meteoData.data.weather[i].precipMM + " mm";
        }
      } else {
        return "";
      }
    },
    getCurrentWindSpeed() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.windspeedKmph
      ) {
        return this.meteoData.data.current_condition.windspeedKmph;
      } else {
        return "";
      }
    },
    getWeatherWindSpeed(i) {
      if (
        this.meteoData.data &&
        this.meteoData.data.weather[i] &&
        this.meteoData.data.weather[i].windspeedKmph
      ) {
        return this.meteoData.data.weather[i].windspeedKmph;
      } else {
        return "";
      }
    },
    getCurrentWindDegree() {
      if (
        this.meteoData.data &&
        this.meteoData.data.current_condition &&
        this.meteoData.data.current_condition.winddirDegree
      ) {
        return this.meteoData.data.current_condition.winddirDegree;
      } else {
        return "";
      }
    },
    getWeatherWindDegree(i) {
      if (
        this.meteoData.data &&
        this.meteoData.data.weather[i] &&
        this.meteoData.data.weather[i].winddirDegree
      ) {
        return this.meteoData.data.weather[i].winddirDegree;
      } else {
        return "";
      }
    },
    getSunriseTime(i) {
      if (
        this.meteoData.dni &&
        this.meteoData.dni.dzien[i] &&
        this.meteoData.dni.dzien[i].wschod
      ) {
        return this.meteoData.dni.dzien[i].wschod;
      } else {
        return "";
      }
    },
    getSunsetTime(i) {
      if (
        this.meteoData.dni &&
        this.meteoData.dni.dzien[i] &&
        this.meteoData.dni.dzien[i].zachod
      ) {
        return this.meteoData.dni.dzien[i].zachod;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.forecast {
  $self: &;

  margin-bottom: 100px;

  &__day {
    margin-bottom: 6px;
  }

  &__item {
    padding-bottom: 24px;
    margin-bottom: 24px;

    &:not(:last-of-type) {
      border-bottom: 1px solid $border-color;
    }

    &:first-of-type {
      #{ $self }__temp {
        font-size: 32px;
      }
    }

    &:not(:first-of-type) {
      #{ $self }__temp {
        font-size: 28px;
      }
    }
  }

  &__row {
    @media (min-width: $screen-sm) {
      display: flex;
    }
  }

  &__main {
    display: flex;
    align-items: center;
    flex: 0 0 38%;
    margin-right: 24px;

    @media (max-width: $screen-xs-max) {
      margin-bottom: 12px;
    }
  }

  &__icon {
    flex: 0 0 92px;
    margin-right: 18px;
    text-align: center;
  }

  &__secondary {
    @media (min-width: $screen-xxs) {
      display: flex;
      margin: 0 -16px;
    }

    @media (min-width: $screen-sm) {
      width: 100%;
    }
  }

  &__details {
    @media (min-width: $screen-xxs) {
      padding: 0 16px;
      width: 100%;
    }

    @media (min-width: $screen-sm) {
      align-self: center;
    }

    > div {
      border-radius: 2px;
      padding: 2px 4px;
      margin-bottom: 2px;

      &:nth-child(even) {
        background-color: #f8f8f8;
      }
    }
  }
}
</style>
